/**
 * Agent Teams Page — merged Crews + Teams view with embedded content.
 */
import React, { Suspense, useState } from 'react'
import { observer } from 'mobx-react-lite'

const CrewsPage = React.lazy(() => import('./CrewsPage'))
const TeamsPage = React.lazy(() => import('./TeamsPage'))

type Tab = 'crews' | 'teams'

const AgentTeamsPage = observer(() => {
  const [activeTab, setActiveTab] = useState<Tab>('crews')

  const tabs: { key: Tab; label: string }[] = [
    { key: 'crews', label: 'Crews' },
    { key: 'teams', label: 'Teams of Crews' },
  ]

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold text-foreground">Agent Teams</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Manage multi-agent crews and team orchestrations
        </p>
      </div>

      <div className="flex gap-1 border-b border-border">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
              activeTab === tab.key
                ? 'border-primary text-primary'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <Suspense fallback={<div className="text-center py-8 text-muted-foreground">Loading...</div>}>
        {activeTab === 'crews' && <CrewsPage />}
        {activeTab === 'teams' && <TeamsPage />}
      </Suspense>
    </div>
  )
})

export default AgentTeamsPage
